import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchTaxEntries = async periodName => await fetch(
  Config.endpoints.FETCH_ADMIN_TAX_ENTRIES
    .replace(/:periodName/, periodName)
).then(handleErrors({ errorMessage: 'Fetching Admin Tax Entries failed' }))
  .then(parseAsJson);

export const importTaxEntries = async (taxEntries, periodName) => await fetch(
  Config.endpoints.IMPORT_ADMIN_TAX_ENTRIES,
  {
    method: 'POST',
    body: JSON.stringify({ taxEntries, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Tax Entries failed' }));

export const fetchYesNoFlag = async () => await fetch(
  Config.endpoints.FETCH_YES_NO_FLAG
).then(handleErrors({ errorMessage: 'Fetching yes_no flag failed' }))
  .then(parseAsJson);

export const fetchTaxEntryType = async () => await fetch(
  Config.endpoints.FETCH_TAX_ENTRY_TYPE
).then(handleErrors({ errorMessage: 'Fetching Tax Entry Type failed' }))
  .then(parseAsJson);

export const fetchTaxEntryActivity = async () => await fetch(
  Config.endpoints.FETCH_TAX_ENTRY_ACTIVITY
).then(handleErrors({ errorMessage: 'Fetching Tax Entry ACTIVITY failed' }))
  .then(parseAsJson);

export const fetchTaxEntryView = async () => await fetch(
  Config.endpoints.FETCH_TAX_ENTRY_VIEW
).then(handleErrors({ errorMessage: 'Fetching Tax Entry View failed' }))
  .then(parseAsJson);

export const insertTaxEntry = async ({ taxEntryData }) => await fetch(
  Config.endpoints.INSERT_ADMIN_TAX_ENTRY
    .replace(/:periodName/, taxEntryData.periodName),
  {
    method: 'POST',
    body: JSON.stringify(taxEntryData),
  }
).then(handleErrors({ errorMessage: 'Adding Tax Entry failed' }));

export const updateTaxEntry = async ({ taxEntryData }) => await fetch(
  Config.endpoints.UPDATE_ADMIN_TAX_ENTRY
    .replace(/:type/, taxEntryData.type)
    .replace(/:activity/, taxEntryData.activity)
    .replace(/:periodName/, taxEntryData.periodName),
  {
    method: 'PUT',
    body: JSON.stringify(taxEntryData),
  }
).then(handleErrors({ errorMessage: 'Updating Tax Entry failed' }));

export const deleteTaxEntry = async ({ periodName, type, activity }) => await fetch(
  Config.endpoints.DELETE_ADMIN_TAX_ENTRY
    .replace(':type', type)
    .replace(':activity', activity)
    .replace(':periodName', periodName), {
    method: 'DELETE',
  }
).then(handleErrors({ errorMessage: 'Removing Tax Entry failed' }));
